import { Check } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { api } from '../services/api'
import toast from 'react-hot-toast'

interface PricingTier {
  id: string
  name: string
  price_per_user: number
  interval: string
  features: string[]
  stripe_price_id: string
}

interface PricingCardProps {
  tier: PricingTier
  isPopular?: boolean
}

const PricingCard: React.FC<PricingCardProps> = ({ tier, isPopular = false }) => {
  const { user } = useAuth()
  const navigate = useNavigate()

  const handleGetStarted = async () => {
    if (!user) {
      navigate('/register')
      return
    }

    try {
      // Create checkout session
      const response = await api.post('/payment/checkout', {
        price_id: tier.stripe_price_id
      })
      
      // Redirect to Stripe checkout
      window.location.href = response.data.url
    } catch (error: any) {
      toast.error(error.response?.data?.error || 'Failed to start checkout')
    }
  }

  const formatPrice = (priceInCents: number) => {
    return (priceInCents / 100).toFixed(2)
  }

  return (
    <div className={`relative card p-8 card-hover ${isPopular ? 'ring-2 ring-chateau-green shadow-2xl scale-105' : ''}`}>
      {isPopular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-gradient-to-r from-chateau-green to-primary-600 text-white px-6 py-2 rounded-full text-sm font-medium shadow-lg">
            Most Popular
          </span>
        </div>
      )}
      
      <div className="text-center mb-8">
        <h3 className="text-3xl font-bold mb-4" style={{color: '#f9fafb'}}>{tier.name}</h3>
        <div className="mb-6">
          <span className="text-5xl font-bold" style={{color: '#3A9E5A'}}>
            ${formatPrice(tier.price_per_user)}
          </span>
          <span className="text-lg" style={{color: '#d1d5db'}}>/user/{tier.interval}</span>
        </div>
      </div>

      <ul className="space-y-4 mb-8">
        {tier.features.map((feature, index) => (
          <li key={index} className="flex items-start">
            <div className="rounded-full p-1 mr-4 mt-0.5 flex-shrink-0" style={{backgroundColor: 'rgba(58, 158, 90, 0.2)'}}>
              <Check className="h-4 w-4" style={{color: '#3A9E5A'}} />
            </div>
            <span className="leading-relaxed" style={{color: '#e5e7eb'}}>{feature}</span>
          </li>
        ))}
      </ul>

      <button
        onClick={handleGetStarted}
        className={`w-full btn ${
          isPopular ? 'btn-primary' : 'btn-outline'
        } text-lg py-4`}
      >
        {user ? 'Manage Subscription' : 'Get Started'}
      </button>
    </div>
  )
}

export default PricingCard
